.seconds {
    max-width: 5rem;
    display: inline-block;
    background: none;
}
